import { StrictMode } from 'react';

import { TooltipProvider } from '@crossnokaye/ux-common';

import { ThemeProvider } from '@/providers/theme-provider';

import { AuthProvider } from './auth/auth-provider';

interface AppProvidersProps {
  children?: React.ReactNode;
}

/**
 * AppProviders adds a stack of cross-cutting concerns to the React context:
 * - Authentication provider
 * - Theme provider
 * - Toaster notifications provider
 *
 * LaunchDarkly is initialized in main.tsx during app bootstrap
 */
export const AppProviders = ({ children }: AppProvidersProps) => {
  return (
    <StrictMode>
      <AuthProvider>
        <ThemeProvider>
          <TooltipProvider>{children}</TooltipProvider>
        </ThemeProvider>
      </AuthProvider>
    </StrictMode>
  );
};
